export enum Theme {
	Light = 'Light',
	Dark = 'Dark',
}
